/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterUserStatBulkItemDto } from '../../models/center-user-stat-bulk-item-dto';

export interface CenterUserControllerGetStatBulk$Params {

/**
 * 시작일
 */
  startAt?: string;

/**
 * 종료일
 */
  endAt?: string;

/**
 * 센터 사용자 ID 목록 (쉼표로 구분)
 */
  centerUserIds: Array<string>;
}

export function centerUserControllerGetStatBulk(http: HttpClient, rootUrl: string, params: CenterUserControllerGetStatBulk$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CenterUserStatBulkItemDto>>> {
  const rb = new RequestBuilder(rootUrl, centerUserControllerGetStatBulk.PATH, 'get');
  if (params) {
    rb.query('startAt', params.startAt, {});
    rb.query('endAt', params.endAt, {});
    rb.query('centerUserIds', params.centerUserIds, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CenterUserStatBulkItemDto>>;
    })
  );
}

centerUserControllerGetStatBulk.PATH = '/api/center-user/stat/bulk';
